import service from '../request/index'


// 微课/文档/研修列表
export function getResourceList(data) {
  return service({
    url: '/es/resource/lib/list',
    method: 'POST',
    data
  })
}
// 资源详情
export function getResourceInfo(data) {
  return service({
    url: '/es/resource/lib/info',
    method: 'get',
    params: data
  })
}
// 资源推荐
export function getRecommendList(data) {
  return service({
    url: '/es/resource/lib/recommend',
    method: 'POST',
    data
  })
}
// 更新浏览数据,更新浏览记录和资源的浏览次数
export function updateResourceNum(data) {
  return service({
    url: '/es/resource/view/update/data',
    method: 'get',
    params: data
  })
}